/* eslint-disable max-nested-callbacks */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import MyModal from "@/components/MyConfirm";
import "./index.less";
import { useTranslation } from "react-i18next";
import { formatFileName, sizeToStr, getFileIconByMime } from "@/utils/chat/index";
import { lookup } from "mime-types";
import { Button, message as toast, Table, Tooltip, Alert, Dropdown } from "antd";
import { changeEgovUrl, getRealConfig } from "@/utils/tools";
import {
  isCrossPlatformGroupSession,
  isOuterContacts,
  sendMessageByKeyboard
} from "@/utils/chat/message";
import { formatFileType } from "@/components/chat/utils/image";
import { nanoid } from "nanoid";
import { DownOutlined } from "@/utils/antdIcon";
import { toPercent } from "@/components/UploadBox/utils";
import bus from "@/utils/bus";
import ChatState from "@/types/chat/State";
import { UserState } from "@/models/user";
import { connect } from "dva";
import { fileCheckName } from "@/api/chat";
import Context from "@/components/chat/context";
import { number } from "echarts/core";
import { isMeetingSessionId } from "@jd/jdee.im.sdk/lib/es/utils/utils";

const LIMIT_SIZE = 5;
const MAX_SIZE = 7;
function UpLoadFile ({
  isMulti,
  title,
  size,
  fileType,
  file,
  fileList,
  visible,
  onCancel,
  onClick,
  userInfo,
  selectedSession,
  isEgovFile,
  onEgovFileCheckedChange,
  dualNet = false,
  teamConfig
}: {
  isMulti: boolean;
  isEgovFile?: boolean;
  title?: string;
  size?: number;
  fileType: string;
  file?: any;
  userInfo?: any;
  selectedSession?: any;
  fileList: any[];
  visible: boolean;
  dualNet?: boolean;
  teamConfig?: any
  onCancel: () => void;
  onClick: (list?: any) => void;
  onEgovFileCheckedChange?: (value: boolean) => void;
}) {
  const { currentFileSendControl, fileTagList, defaultFileTag = 0 } = React.useContext(Context);
  const defaultFileTagRef = useRef<number>(defaultFileTag);
  const [t] = useTranslation("chat");
  const [fileIcon, progressColor, ic_fileIcon] = useMemo(() => {
    return getFileIconByMime(fileType || (title && lookup(title)) || "");
  }, [fileType, title]);
  const size_str = useMemo(() => {
    return sizeToStr(size || 0);
  }, [size]);

  // 多文件发送
  const [selectedRowKeys, setSelectedRowKeys] = useState<Array<string>>([]);
  const [selectedRow, setSelectedRow] = useState<Array<any>>([]);
  const [tableData, setTableData] = useState(fileList);
  const [loading, setLoading] = useState(true);
  const [onDisabled, setOnDisabled] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [showEgovFile] = useState(false);

  // 读取文件提示栏配置
  const filePromptConfig = useMemo(() => {
    const filePromptBarSwitch = getRealConfig(teamConfig, {}, "filePromptBarSwitch");
    const filePromptBarText = getRealConfig(teamConfig, {}, "filePromptBarText");
    console.log("filePromptBarSwitch, filePromptBarText", teamConfig, filePromptBarSwitch, filePromptBarText);
    const shouldShow = filePromptBarSwitch;
    const alertText = filePromptBarText || "注意：为保证文件安全有序流转，请根据文件内容重要程度选择标签和传输网络";   
    return {
      shouldShow,
      alertText
    };
  }, [teamConfig]);
  const handleKeyDown = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    // console.log('mention keydown', e.key);
    if (e.key !== "Enter") return;
    const isCanSend = sendMessageByKeyboard(e, isMulti, selectedRow);
    if (!isCanSend) {
      toast.warning("至少选择一个文件发送");
      return;
    }
    onClick(selectedRow);
  };

  const isOutApp = useMemo(() => {
    return selectedSession.isGroup
      ? isCrossPlatformGroupSession(selectedSession)
      : isOuterContacts(selectedSession, userInfo);
  }, [selectedSession, userInfo]);

  const checkFiles = useCallback(
    (newFiles: any[]) => {
      // 检测文件名
      // 会议不检测文件名
      if (isMeetingSessionId(selectedSession?.sessionId)) {
        return;
      }
      const names = newFiles.map((f: any) => f.title);
      if (names?.length) {
        fileCheckName({
          nameList: names
        })
          .then((res: any) => {
            const { secretNameList = [] } = res || {};
            // 更新
            if (secretNameList?.length) {
              const newData = newFiles.map((item: any) => {
                if (secretNameList.includes(item?.title)) {
                  item.isSecret = true;
                }
                return item;
              });
              setTableData(newData);
            }
          })
          .catch((e) => {
            console.log("fileCheckName>>error>>", e);
          });
      }
    },
    [selectedSession.sessionId]
  );
  useEffect(() => {
    if (!visible) {
      return;
    }
    formatFileType(Array.from(fileList)).then((data) => {
      const newFiles = data.map((file: any) => {
        if (file.loaded < 100) {
          setOnDisabled(true);
          setLoading(true);
        } else if (file.loaded === undefined) {
          setOnDisabled(false);
          setLoading(false);
        }
        return {
          file,
          title: file.name,
          size: file.size,
          fileType: file.type || lookup(file.name) || "",
          fileId: nanoid(20),
          fileTag: defaultFileTagRef.current
        };
      });
      checkFiles(newFiles);
      setTableData(newFiles);
      if (!newFiles.length) {
        setLoading(!newFiles.length);
      }
      if (newFiles.length <= LIMIT_SIZE) {
        const ids = newFiles.map((item: any) => item.fileId);
        setSelectedRowKeys(ids);
        setSelectedRow(newFiles);
      } else {
        setSelectedRowKeys([]);
        setSelectedRowKeys([]);
      }
    });
  }, [fileList, visible, checkFiles]);

  // 设置class类
  useEffect(() => {
    if (tableData.length > LIMIT_SIZE) {
      const disbleRows = document.querySelectorAll(".ant-checkbox-wrapper-disabled");
      if (disbleRows.length) {
        disbleRows.forEach((ele) => {
          const tr = ele.parentNode?.parentNode as Element;
          tr.classList.add("over-max-num-disabled");
          setIsDisabled(true);
        });
      } else {
        if (isDisabled) {
          const disbleTr = document.querySelectorAll(".over-max-num-disabled");
          if (disbleTr.length) {
            disbleTr.forEach((ele) => {
              ele.classList.remove("over-max-num-disabled");
            });
          }
          setIsDisabled(false);
        }
      }
    }
  }, [tableData, selectedRowKeys, isDisabled]);

  function getFileType (record: any) {
    const [fileIcon, progressColor, ic_fileIcon] = getFileIconByMime(
      record.fileType || (record.title && lookup(record.title)) || ""
    );
    return ic_fileIcon;
  }

  function getCheckboxProps (record: any) {
    return {
      disabled: selectedRowKeys.length >= LIMIT_SIZE && !selectedRowKeys.includes(record.fileId)
    };
  }

  function rowSelectChange (selectedkeys: any, selectedRows: any) {
    // console.log('选中的值', selectedkeys, selectedRows);
    if (tableData.length > LIMIT_SIZE && selectedkeys.length > LIMIT_SIZE) {
      // message.warn('最多选择5个文件');
      return;
    } else {
      setSelectedRowKeys(selectedkeys);
      setSelectedRow(selectedRows);
    }
  }

  const onEgovFileChange = (value: number, index: number) => {
    tableData[index].egovFile = value;
    setTableData([...tableData]);
  };

  const onFileTagChange = (value: number, index: number) => {
    tableData[index].fileTag = value;
    setTableData([...tableData]);
  };

  const getCurrTagName = (item: any) => {
    return fileTagList?.find((i) => i.tagId === item.fileTag)?.tagName || "查看";
  };

  const columns: any = [
    {
      title: "文件名称",
      width: "250px",
      dataIndex: "title",
      align: "left",
      ellipsis: true,
      render: (title: string, record: any) => {
        const icon_src = getFileType(record);
        return (
          <div className="file_title">
            <img src={changeEgovUrl(icon_src)} draggable="false" />
            <Tooltip title={title} overlayClassName="multi-file-tooltip" placement="bottom">
              <div className="file_title_text">
                <div className="text ellipsis">{title}</div>
                {record.isSecret ? (
                  <span className="tip-file-title">文件可能涉及敏感信息，请检查标签</span>
                ) : null}
              </div>
            </Tooltip>
          </div>
        );
      }
    },
    {
      title: "文件大小",
      width: "80px",
      dataIndex: "size",
      align: "center",
      render: (size: number) => {
        const sizeText = sizeToStr(size || 0);
        return <div>{sizeText}</div>;
      }
    }
  ];
  // 文件打标
  if (dualNet && currentFileSendControl?.length && currentFileSendControl?.length > 1) {
    columns.push({
      title: "文件标签",
      width: "90px",
      dataIndex: "fileTag",
      render: (text: number, record: any, index: number) => {
        if (
          (record.fileType.indexOf("image") > -1 && record.size < 10 * 1024 * 1024) ||
          !currentFileSendControl?.length
        ) {
          return null;
        }
        if (currentFileSendControl?.length === 1) {
          return (
            <a
              className="ant-dropdown-link"
              style={{
                marginRight: 10,
                color: text ? "#ED6A0C" : "#1686FF",
                paddingLeft: "6px"
              }}
              onClick={(e) => e.preventDefault()}
            >
              {getCurrTagName(record)}
            </a>
          );
        }
        return (
          <Dropdown
            overlay={
              <div className="upload-egov-file-dropdown">
                {currentFileSendControl?.length && currentFileSendControl?.length > 1 ? (
                  currentFileSendControl?.map((item: any, idx: number) => {
                    return (
                      <div
                        key={`tag_${idx}`}
                        className={`menu-item egov-item tag-${item.tagId} ${
                          text === item.tagId
                            ? `${item.tagId === 0 ? "active" : "active-egov"}`
                            : ""
                        }`}
                        onClick={() => onFileTagChange(item.tagId, index)}
                      >
                        <div className="menu-item-text">{item.tagName}</div>
                        <div className="menu-item-text menu-item-desc">{item.tagDesc}</div>
                      </div>
                    );
                  })
                ) : (
                  <div />
                )}
              </div>
            }
            placement="bottomCenter" /* trigger={['click']} */
          >
            <a
              className="ant-dropdown-link"
              style={{
                marginRight: 10,
                color: text ? "#ED6A0C" : "#1686FF",
                paddingLeft: "6px"
              }}
              onClick={(e) => e.preventDefault()}
            >
              {getCurrTagName(record)}
              <DownOutlined />
            </a>
          </Dropdown>
        );
      }
    });
  }
  if (showEgovFile) {
    columns.push({
      title: "查看方式",
      width: "120px",
      dataIndex: "egovFile",
      render: (text: number, record: any, index: number) => {
        if (record.fileType.indexOf("image") > -1) {
          if (record.size > 10 * 1024 * 1024) {
            return (
              <Dropdown
                overlay={
                  <div className="upload-egov-file-dropdown">
                    <div
                      className={`menu-item ${!text ? "active" : ""}`}
                      onClick={() => onEgovFileChange(0, index)}
                    >
                      <div className="menu-item-text">双网</div>
                      <div className="menu-item-text menu-item-desc">互联网和政务外网均可查看</div>
                    </div>
                    <div
                      className={`menu-item egov-item ${text ? "active-egov" : ""}`}
                      onClick={() => onEgovFileChange(1, index)}
                    >
                      <div className="menu-item-text">仅政务外网</div>
                      <div className="menu-item-text menu-item-desc">
                        仅PC端政务外网可查看，其他网络不可查看
                      </div>
                    </div>
                  </div>
                }
                placement="bottomCenter" /* trigger={['click']} */
              >
                <a
                  className="ant-dropdown-link"
                  style={{
                    marginRight: 10,
                    color: text ? "#ED6A0C" : "#1686FF",
                    paddingLeft: "6px"
                  }}
                  onClick={(e) => e.preventDefault()}
                >
                  {text ? "仅政务外网" : "双网"}
                  <DownOutlined />
                </a>
              </Dropdown>
            );
          }
          return null;
        } else {
          return (
            <Dropdown
              disabled={!isOutApp ? false : true}
              overlay={
                <div className="upload-egov-file-dropdown">
                  <div
                    className={`menu-item ${!text ? "active" : ""}`}
                    onClick={() => onEgovFileChange(0, index)}
                  >
                    <div className="menu-item-text">双网</div>
                    <div className="menu-item-text menu-item-desc">互联网和政务外网均可查看</div>
                  </div>
                  <div
                    className={`menu-item egov-item ${text ? "active-egov" : ""}`}
                    onClick={() => onEgovFileChange(1, index)}
                  >
                    <div className="menu-item-text">仅政务外网</div>
                    <div className="menu-item-text menu-item-desc">
                      仅PC端政务外网可查看，其他网络不可查看
                    </div>
                  </div>
                </div>
              }
              placement="bottomCenter" /* trigger={['click']} */
            >
              <a
                className="ant-dropdown-link"
                style={{
                  marginRight: 10,
                  color: text ? "#ED6A0C" : "#1686FF",
                  paddingLeft: "6px"
                }}
                onClick={(e) => e.preventDefault()}
              >
                {text ? "仅政务外网" : "双网"}
                <DownOutlined />
              </a>
            </Dropdown>
          );
        }
      }
    });
  }

  return (
    <MyModal
      title={t("send_content")}
      toolTip={t("max_file_num").replace("%s", `${LIMIT_SIZE}`)}
      onCancel={onCancel}
      onClick={() => onClick(selectedRow)}
      onKeyDown={handleKeyDown}
      isKeyboard={true}
      visible={visible}
      disabled={!selectedRowKeys.length || !tableData.length || onDisabled}
      selfClass="multi-file"
    >
      {dualNet && !!filePromptConfig.shouldShow && (
        <Alert
          className="upload-egov-file-alert"
          message={filePromptConfig.alertText}
          type="warning"
          showIcon
        />
      )}
      <Table
        columns={columns}
        dataSource={tableData}
        loading={loading}
        locale={{ emptyText: "暂无数据" }}
        pagination={false}
        scroll={{ y: 268 }}
        rowKey="fileId"
        rowClassName="multi-file-list-table-row"
        rowSelection={{
          columnWidth: 40,
          getCheckboxProps,
          hideSelectAll: tableData.length > LIMIT_SIZE ? true : false,
          selectedRowKeys,
          onChange: rowSelectChange
        }}
      />
    </MyModal>
  );
}

function mapStateToProps ({ chat, user }: { chat: ChatState, user: UserState }) {
  const { currentEmployee, selectedSession } = chat;
  return {
    userInfo: currentEmployee,
    currentEmployee,
    selectedSession,
    teamConfig: user.teamConfig
  };
}

function mapDispatchToProps () {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(UpLoadFile);
